<template>
  <div class="product-viewer">
    <div v-show="!showVTO">
      <template v-if="smallScreen">
        <slider
          :previous-panel-text="previousPanelText"
          :next-panel-text="nextPanelText"
          :per-page="1"
          :start-at="activeItem"
          :navigation-enabled="true"
          :pagination-enabled="true"
          :is-pagination-clickable="false"
          :tagging-labels="taggingLabels"
          ref="slider"
          @pageChange="whenPageChange"
        >
          <slide v-for="(item, index) in mediaArray" :key="index">
            <slot :name="item" v-if="isSlotData(item)" />
            <div v-else class="product-viewer__img variant-image">
              <img :src="item.ImgSrcset['360']" v-srcset="item.ImgSrcset" alt="some text">
              <noscript>
                <!-- SEO-->
                <img :src="item.ImgSrcset['360']" alt="some text" class="product-card__img">
              </noscript>
            </div>
          </slide>
        </slider>
      </template>
      <template v-else>
        <div class="product-viewer__wrapper">

          <ul class="product-viewer__product-images">
            <li v-for="(item, index) in mediaArray" :key="index"
                class="product-viewer__product-image"
                :class="{'product-viewer__product-image--active': index === activeItem}">
              <slot :name="item" v-if="isSlotData(item)" />
              <div v-else class="product-viewer__img variant-image">
                <img :src="item.ImgSrcset['1024']" v-srcset="item.ImgSrcset" alt="some text">
                <noscript>
                  <!-- SEO-->
                  <img :src="item.ImgSrcset['1024']" alt="some text" class="product-card__img">
                </noscript>
              </div>
            </li>
          </ul>

          <div class="product-viewer__previews">
            <slider
              :previous-panel-text="previousPanelText"
              :next-panel-text="nextPanelText"
              :per-page-custom="[[320, 3], [768, 5]]"
              :loop="false"
              :scroll-per-page="true"
              :start-at="activeItem"
              :navigation-enabled="true"
              :pagination-enabled="false"
              :swipe-on-desktop="false"
              ref="slider"
              @pageChange="whenPageChange"
            >
              <slide v-for="(item, index) in thumbArray" :key="index" :current="index === activeItem">
                <button class="product-viewer__preview"
                        :class="{'product-viewer__preview--active': index === activeItem}"
                        @click="setActive(index, true)">
                  <slot :name="item" v-if="isSlotData(item)" />
                  <img v-else role="img" :src="item.thumb"
                       alt="some text">
                </button>
              </slide>
            </slider>
          </div>
        </div>
      </template>
    </div>
    <div class="product-viewer__previews" v-if="productDetails.isProductModifaceEnabled === true">
      <h3 class="product-viewer__previews__title"><strong>{{dataTextTitle}} </strong></h3>
       <div class="product-viewer__previews__description"> {{dataTextDescription}}</div>
    </div>
    <virtual-tryon
		:modiface-settings="modifaceSettings"
		:product-details="productDetails"
		:product-category="productCategory"
		:upc-list="upc"
		:colors-list="colorList"
		:live-camera-text="liveCameraText"
		:upload-image-text="uploadImageText"/>
  </div>
</template>

<script>
  import { eventBus } from '@EventBus';
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import Slide from '@Feature/Slider/code/Scripts/components/slide/slide';
  import Slider from '@Feature/Slider/code/Scripts/components/slider/slider';
  import { mapGetters } from 'vuex';
  import { srcset } from '@Foundation/directives/srcset/srcset';
  import virtualTryon from '@Feature/VTO/Code/Scripts/components/virtual-tryon';

  export default {
    name: 'product-viewer',
    components: {
      Slide,
      Slider,
      virtualTryon
    },
    directives: {
      srcset
    },
    props: {
      taggingLabels: { type: Object, require: false, default: null },
      nextPanelText: { type: String, required: false, default: 'next panel' },
      previousPanelText: { type: String, required: false, default: 'previous panel' },
      modifaceSettings: { type: Object, required: false },
      productDetails: { type: Object, required: false },
      productCategory: { type: String, required: false },
      upcList: { type: Array, required: false },
      colorsList: { type: Array, required: false },
      liveCameraText: { type: String, required: false },
      uploadImageText: { type: String, required: false },
      dataTextTitle: { type: String, required: false },
      dataTextDescription: { type: String, required: false }
    },

    data() {
      return {
        carouselIdentifier: '',
        activeItem: 0,
        smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
        previews: false,
        productImages: false,
        mediaArray: [],
        thumbArray: [],
        showVTO: false,
        colorList: this.colorsList,
        upc: this.upcList
      };
    },
    computed: {
      ...mapGetters(['preferredProductVariant']),
      getVTO() {
        return this.$store.getters.getVTO;
      },
    },
    watch: {
      preferredProductVariant(val) {
        // remove previously selected items
        this.removeVariantImages();
        // prepend new items
        val.imgUrl.map(value => {
          this.mediaArray.unshift(value);
          this.thumbArray.unshift(value);
        });
        this.$refs.slider.goToPage(0);
        this.setActive(0, false);
      },
    },
    mounted() {
      this.setSlots('media');
      this.setSlots('thumb');
      // test runner cannot deal with eventbBus
      /* istanbul ignore next */
      eventBus.$on('mediaquery::changed', mq => {
        this.smallScreen = !!(mq.size === 'small' || mq.size === 'medium');
        if (!this.smallScreen) {
          this.setActive(this.activeItem, this.smallScreen);
        }
      });

      if (!this.smallScreen) {
        this.setActive(this.activeItem, false, false);
      }

      window.eventBus.$on('checkTryiton',() => {
        setTimeout(() => {
          this.showVTO = true;
        }, 300);
      });
      window.eventBus.$on('hideVTO',() => {
        setTimeout(() => {
          this.showVTO = false;
        }, 300);
      });
      window.eventBus.$on('showPDP',(data) => {
        setTimeout(() => {
          this.showVTO = data;
        }, 300);
      });
    },
    methods: {

      isSlotData(data) {
        if (data) {
          return typeof data !== 'object';
        }
      },
      removeVariantImages() {
        this.mediaArray = this.mediaArray.filter(item => this.isSlotData(item));
        this.thumbArray = this.thumbArray.filter(item => this.isSlotData(item));
      },
      whenPageChange(currentPage, prevPage, actionType) {
        document.dispatchEvent(new CustomEvent('carouselLazyImg'));

        if (actionType === 'navigation' && this.smallScreen) {
          AnalyticsHandler.pushDataLayer({
            'event': 'uaevent',
            'ecommerce': 'undefined',
            'eventCategory': 'product detail page',
            'eventAction': `select::${currentPage > prevPage ? 'next' : 'previous'}`,
            'eventLabel': `${currentPage + 1}::${this.taggingLabels.label[currentPage]}`
          });
        } else if (actionType === 'navigation') {
          AnalyticsHandler.pushDataLayer({
            'event': 'uaevent',
            'ecommerce': 'undefined',
            'eventCategory': 'product detail page',
            'eventAction': `select::${currentPage > prevPage ? 'next' : 'previous'}`,
            'eventLabel': 'product-viewer'
          });
        } else if (actionType === 'pagination') {
          AnalyticsHandler.pushDataLayer({
            'event': 'uaevent',
            'ecommerce': 'undefined',
            'eventCategory': 'product detail page',
            'eventLabel': `${currentPage + 1}::${this.taggingLabels.label[currentPage]}`
          });
        }
      },
      setSlots(slotName) {
        Object.keys(this.$slots).forEach((item) => {
          if (item.indexOf(slotName) !== -1) {
            switch (slotName) {
              case 'media':
                this.mediaArray.push(item);
                break;
              case 'thumb':
                this.thumbArray.push(item);
                break;
            }
          }
        });
      },
      setActive(index, addFocus = true) {
        // pause all players
        /* istanbul ignore next */
        Array.prototype.forEach.call(document.querySelectorAll('iframe'), player => {
          player.contentWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
        });

        this.activeItem = index;

        this.$nextTick(() => {
          this.previews = document.querySelectorAll('.product-viewer__preview');

          if (addFocus) {
            this.previews[this.activeItem].focus();
          }
        });
      },
    },
  };
</script>

<style lang="scss" src="./product-viewer.scss"></style>
